import { computed } from "vue";

const TARGET_ROLE_MAP = {
  customers: ["customer-service"],
  contacts: ["customer-service"],
  invoices: ["finance-department", "finance-audit", "finance-audits"],
  quotes: ["customer-service"],
  tickets: ["customer-service"],
  staff: ["operational", "finance-department"],
  vehicles: ["operational", "finance-department"],
  references: ["operational", "finance-department"],
  job_dates: ["operational", "finance-department"],
  suppliers: ["finance-department", "operational", "standard"],
  requisitions: ["finance-department", "operational", "standard"],
};

const ENDPOINT_TARGET_MAP = {
  "/api/customer/search": "customers",
  "/api/contact/search": "contacts",
  "/api/invoice/search": "invoices",
  "/api/quote/search": "quotes",
  "/api/quote/comparison-reference/search": "quotes",
  "/api/ticket/search": "tickets",
  "/api/staff/search": "staff",
  "/api/reference/search": "references",
  "/api/job-date/search": "job_dates",
  "/api/vehicle/search": "vehicles",
  "/api/supplier/search": "suppliers",
  "/api/requisition/search": "requisitions",
};

const normalizeRoles = (roles) =>
  new Set((roles || []).map((role) => String(role).toLowerCase()));

export const isSearchTargetAllowed = (target, roles = []) => {
  const allowedRoles = TARGET_ROLE_MAP[target];
  if (!allowedRoles) {
    return true;
  }
  const roleSet = normalizeRoles(roles);
  if (roleSet.has("super")) {
    return true;
  }
  return allowedRoles.some((role) => roleSet.has(role));
};

export const isSearchEndpointAllowed = (url, roles = []) => {
  if (!url) {
    return true;
  }
  const base = String(url).split("?")[0].toLowerCase();
  const target = ENDPOINT_TARGET_MAP[base];
  if (!target) {
    return true;
  }
  return isSearchTargetAllowed(target, roles);
};

export const filterSearchResults = (results, roles = []) => {
  const filtered = {};
  Object.entries(results || {}).forEach(([target, items]) => {
    if (isSearchTargetAllowed(target, roles)) {
      filtered[target] = items;
    }
  });
  return filtered;
};

export const useSearchAccess = (rolesRef) => {
  const roles = computed(() => rolesRef?.value ?? []);
  const canSearchTarget = (target) => isSearchTargetAllowed(target, roles.value);
  const canSearchEndpoint = (url) => isSearchEndpointAllowed(url, roles.value);
  return { canSearchTarget, canSearchEndpoint };
};
